/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vpn_Action_PhraseInputs */

const en_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`subscribe`)
};

const id_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`berlangganan`)
};

const ms_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`langgani`)
};

const ca_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`subscriu-te`)
};

const cs_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`odebírat`)
};

const da_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tilmeld`)
};

const de_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnieren`)
};

const et_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`telli`)
};

const es_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`suscríbete`)
};

const fr_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`s’abonner`)
};

const hr_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pretplatite se`)
};

const it_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iscriviti`)
};

const lv_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abonēt`)
};

const lt_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prenumeruoti`)
};

const hu_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`feliratkozás`)
};

const nl_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abonneren`)
};

const nb_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abonner`)
};

const pl_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`subskrybuj`)
};

const pt_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`assinar`)
};

const ro_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abonare`)
};

const sk_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`predplatiť`)
};

const sl_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`naročite se`)
};

const fi_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tilaa`)
};

const sv_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prenumerera`)
};

const vi_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`đăng ký`)
};

const tr_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`abone ol`)
};

const el_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`εγγραφή`)
};

const bg_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`абониране`)
};

const ru_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`подписаться`)
};

const sr_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`претплатите се`)
};

const uk_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`підписатися`)
};

const ka_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გამოწერა`)
};

const hi_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सब्सक्राइब `)
};

const th_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สมัครสมาชิก`)
};

const ko_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구독`)
};

const zh_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅`)
};

const zh_tw_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`訂閱`)
};

const ja_vpn_action_phrase = /** @type {(inputs: Vpn_Action_PhraseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`購入する`)
};

/**
* | output |
* | --- |
* | "subscribe" |
*
* @param {Vpn_Action_PhraseInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const vpn_action_phrase = /** @type {((inputs?: Vpn_Action_PhraseInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vpn_Action_PhraseInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_vpn_action_phrase(inputs)
	if (locale === "ms") return ms_vpn_action_phrase(inputs)
	if (locale === "ca") return ca_vpn_action_phrase(inputs)
	if (locale === "cs") return cs_vpn_action_phrase(inputs)
	if (locale === "da") return da_vpn_action_phrase(inputs)
	if (locale === "de") return de_vpn_action_phrase(inputs)
	if (locale === "et") return et_vpn_action_phrase(inputs)
	if (locale === "es") return es_vpn_action_phrase(inputs)
	if (locale === "fr") return fr_vpn_action_phrase(inputs)
	if (locale === "hr") return hr_vpn_action_phrase(inputs)
	if (locale === "it") return it_vpn_action_phrase(inputs)
	if (locale === "lv") return lv_vpn_action_phrase(inputs)
	if (locale === "lt") return lt_vpn_action_phrase(inputs)
	if (locale === "hu") return hu_vpn_action_phrase(inputs)
	if (locale === "nl") return nl_vpn_action_phrase(inputs)
	if (locale === "nb") return nb_vpn_action_phrase(inputs)
	if (locale === "pl") return pl_vpn_action_phrase(inputs)
	if (locale === "pt") return pt_vpn_action_phrase(inputs)
	if (locale === "ro") return ro_vpn_action_phrase(inputs)
	if (locale === "sk") return sk_vpn_action_phrase(inputs)
	if (locale === "sl") return sl_vpn_action_phrase(inputs)
	if (locale === "fi") return fi_vpn_action_phrase(inputs)
	if (locale === "sv") return sv_vpn_action_phrase(inputs)
	if (locale === "vi") return vi_vpn_action_phrase(inputs)
	if (locale === "tr") return tr_vpn_action_phrase(inputs)
	if (locale === "el") return el_vpn_action_phrase(inputs)
	if (locale === "bg") return bg_vpn_action_phrase(inputs)
	if (locale === "ru") return ru_vpn_action_phrase(inputs)
	if (locale === "sr") return sr_vpn_action_phrase(inputs)
	if (locale === "uk") return uk_vpn_action_phrase(inputs)
	if (locale === "ka") return ka_vpn_action_phrase(inputs)
	if (locale === "hi") return hi_vpn_action_phrase(inputs)
	if (locale === "th") return th_vpn_action_phrase(inputs)
	if (locale === "ko") return ko_vpn_action_phrase(inputs)
	if (locale === "zh") return zh_vpn_action_phrase(inputs)
	if (locale === "zh-tw") return zh_tw_vpn_action_phrase(inputs)
	if (locale === "ja") return ja_vpn_action_phrase(inputs)
	return en_vpn_action_phrase(inputs)
});